import React, { useContext } from 'react';

/* packages */
import Fetch from '../../../util-fetch';
/* packages */

/* stores */
import ConfirmStore from './store';
/* stores */

const Index = ({CONFIG, token}) => {
  const orderConfirmContext  = useContext(ConfirmStore);
  const orderConfirmMethod = async (body, orderId) => {
    orderConfirmContext.setLoading(true);
    CONFIG.application.confirmation.api.headers.Authorization = token;
    const fetch = await Fetch({
      url: CONFIG.application.confirmation.api.endpoints.create.url + orderId,
      config: {
        method: CONFIG.application.confirmation.api.endpoints.create.method,
        headers: CONFIG.application.confirmation.api.headers,
        body
      }
    });
    orderConfirmContext.setStatus(fetch[0]);
    orderConfirmContext.setData(fetch[1]);
    orderConfirmContext.setLoading(false);
  }
  const orderConfirmData = orderConfirmContext.isData();

  return { orderConfirmContext, orderConfirmMethod, orderConfirmData }
}

export default Index;
